import type { ItemFoldersAPIContentTypes } from '~/elc/features/admin-common';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import FetchPromise from '~/agent/fetch-promise';
import { skillsKeys } from '~/elc/features/skills';
import { UNIVERSITY_API_ROOT_URL } from '../constants';
import { GET_LIBRARY_KEY } from './getLibraryContent';

export type LibraryAsset = {
  id: string;
  type: ItemFoldersAPIContentTypes;
};

export type AddLibraryContentProps = {
  libraryId: string;
  data: {
    university_folder_id: string;
    assets: LibraryAsset[];
  };
};

export function addLibraryContent({ libraryId, data }: AddLibraryContentProps): Promise<boolean> {
  return FetchPromise.post(`${UNIVERSITY_API_ROOT_URL}/${libraryId}/assets`, data);
}

export function useAddLibraryContent(libraryId: string) {
  const queryClient = useQueryClient();
  return useMutation(addLibraryContent, {
    onSuccess: async () => {
      const skillKeyToInvalidate = skillsKeys.librarySkills({ id: libraryId });
      const tagsKeyToInvalidate = ['get-library-content-tags', libraryId];
      const keyToInvalidate = [GET_LIBRARY_KEY];
      await queryClient.invalidateQueries(keyToInvalidate);
      await queryClient.invalidateQueries(skillKeyToInvalidate);
      await queryClient.invalidateQueries(tagsKeyToInvalidate);
    },
  });
}
